import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { resendConfirmationEmail } from "../../processes/signUpProcesses";
import ResendConfirmationEmailForm from "./ResendConfirmationEmailForm";

function mapStateToProps() {
  return {
    initialValues: {},
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    form: "resendConfirmationEmail",
    onSubmit: resendConfirmationEmail,
  })(ResendConfirmationEmailForm)
);
